import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
} from '@mui/material'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import { closeModal } from '../store/slice/appSlice'

const CommonModal = () => {
	const { isShow, message } = useAppSelector((state) => state.app.commonModal)
	const dispatch = useAppDispatch()

	const handleClose = () => {
		dispatch(closeModal())
	}

	return (
		<Dialog
			open={isShow}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} autoFocus>
					Закрити
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default CommonModal
